jQuery(document).ready(function($) {

    const $menuprimary = $('#primary-menu'),
        primaryInitialFromtop = $menuprimary.offset().top,
        $body = $('body')
        primaryFromtop = 0;
    
    function setScrollClass() {
        primaryFromtop = $menuprimary.offset().top;
        const primaryFromVp= primaryFromtop - $(window).scrollTop()
        if ( primaryFromVp <= -100) {
            $body.addClass("primary-fixed");
        }
    }

    setScrollClass();

    $(window).scroll(function() {

        setScrollClass()
       
        if ( primaryFromtop < primaryInitialFromtop) {
            $body.removeClass("primary-fixed");            
        }

    });

});